// Country data interface
export interface CountryData {
  code: string;
  name: string;
  flag: string;
}

// Organized country data by continents
export const countriesByContinent: Record<string, CountryData[]> = {
  popular: [
    { code: 'PS', name: 'Palestine', flag: '🇵🇸' },
    { code: 'JO', name: 'Jordan', flag: '🇯🇴' },
    { code: 'IL', name: 'Israel', flag: '🇮🇱' },
    { code: 'US', name: 'United States', flag: '🇺🇸' },
    { code: 'CA', name: 'Canada', flag: '🇨🇦' },
  ],
  'North America': [
    { code: 'MX', name: 'Mexico', flag: '🇲🇽' },
    { code: 'CU', name: 'Cuba', flag: '🇨🇺' },
    { code: 'DO', name: 'Dominican Republic', flag: '🇩🇴' },
    { code: 'CR', name: 'Costa Rica', flag: '🇨🇷' },
    { code: 'PA', name: 'Panama', flag: '🇵🇦' },
    { code: 'JM', name: 'Jamaica', flag: '🇯🇲' },
  ],
  'South America': [
    { code: 'BR', name: 'Brazil', flag: '🇧🇷' },
    { code: 'AR', name: 'Argentina', flag: '🇦🇷' },
    { code: 'CO', name: 'Colombia', flag: '🇨🇴' },
    { code: 'PE', name: 'Peru', flag: '🇵🇪' },
    { code: 'CL', name: 'Chile', flag: '🇨🇱' },
    { code: 'EC', name: 'Ecuador', flag: '🇪🇨' },
    { code: 'UY', name: 'Uruguay', flag: '🇺🇾' },
    { code: 'BO', name: 'Bolivia', flag: '🇧🇴' },
  ],
  'Europe': [
    { code: 'GB', name: 'United Kingdom', flag: '🇬🇧' },
    { code: 'AU', name: 'Australia', flag: '🇦🇺' },
    { code: 'DE', name: 'Germany', flag: '🇩🇪' },
    { code: 'FR', name: 'France', flag: '🇫🇷' },
    { code: 'ES', name: 'Spain', flag: '🇪🇸' },
    { code: 'IT', name: 'Italy', flag: '🇮🇹' },
    { code: 'NL', name: 'Netherlands', flag: '🇳🇱' },
    { code: 'PT', name: 'Portugal', flag: '🇵🇹' },
    { code: 'BE', name: 'Belgium', flag: '🇧🇪' },
    { code: 'CH', name: 'Switzerland', flag: '🇨🇭' },
    { code: 'AT', name: 'Austria', flag: '🇦🇹' },
    { code: 'GR', name: 'Greece', flag: '🇬🇷' },
    { code: 'SE', name: 'Sweden', flag: '🇸🇪' },
    { code: 'NO', name: 'Norway', flag: '🇳🇴' },
    { code: 'DK', name: 'Denmark', flag: '🇩🇰' },
    { code: 'FI', name: 'Finland', flag: '🇫🇮' },
    { code: 'IE', name: 'Ireland', flag: '🇮🇪' },
    { code: 'PL', name: 'Poland', flag: '🇵🇱' },
    { code: 'CZ', name: 'Czech Republic', flag: '🇨🇿' },
    { code: 'HU', name: 'Hungary', flag: '🇭🇺' },
    { code: 'RO', name: 'Romania', flag: '🇷🇴' },
  ],
  'Asia': [
    { code: 'CN', name: 'China', flag: '🇨🇳' },
    { code: 'JP', name: 'Japan', flag: '🇯🇵' },
    { code: 'KR', name: 'South Korea', flag: '🇰🇷' },
    { code: 'IN', name: 'India', flag: '🇮🇳' },
    { code: 'PS', name: 'Palestine', flag: '🇵🇸' },
    { code: 'AE', name: 'United Arab Emirates', flag: '🇦🇪' },
    { code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦' },
    { code: 'TH', name: 'Thailand', flag: '🇹🇭' },
    { code: 'SG', name: 'Singapore', flag: '🇸🇬' },
    { code: 'MY', name: 'Malaysia', flag: '🇲🇾' },
    { code: 'VN', name: 'Vietnam', flag: '🇻🇳' },
    { code: 'PH', name: 'Philippines', flag: '🇵🇭' },
    { code: 'ID', name: 'Indonesia', flag: '🇮🇩' },
    { code: 'TR', name: 'Turkey', flag: '🇹🇷' },
  ],
  'Africa': [
    { code: 'ZA', name: 'South Africa', flag: '🇿🇦' },
    { code: 'EG', name: 'Egypt', flag: '🇪🇬' },
    { code: 'NG', name: 'Nigeria', flag: '🇳🇬' },
    { code: 'KE', name: 'Kenya', flag: '🇰🇪' },
    { code: 'MA', name: 'Morocco', flag: '🇲🇦' },
    { code: 'TN', name: 'Tunisia', flag: '🇹🇳' },
    { code: 'GH', name: 'Ghana', flag: '🇬🇭' },
    { code: 'SN', name: 'Senegal', flag: '🇸🇳' },
  ],
  'Oceania': [
    { code: 'NZ', name: 'New Zealand', flag: '🇳🇿' },
    { code: 'FJ', name: 'Fiji', flag: '🇫🇯' },
    { code: 'PG', name: 'Papua New Guinea', flag: '🇵🇬' },
  ]
};

export default countriesByContinent; 